import {request} from '@/utils/request'

//查询送货单详情
export function sentFormQuery(data, that, loading = false) {
    return request({
        url: '/srm/sentForm/sentFormQuery',
        data: data,
        params: {},
        that,
        method: 'post',
        loading: loading,
    })
}
//查询所有送货单
export function searchAllSentForm(data, that) {
    return request({
        url: '/srm/sentForm/searchAllSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//删除送货单
export function delSentForm(data, that) {
    return request({
        url: '/srm/sentForm/delSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//更新送货单状态
export function updateFormStatus(data, that) {
    return request({
        url: '/srm/sentForm/updateFormStatus',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}
//修改送货单
export function updateSentForm(data, that) {
    return request({
        url: '/srm/sentForm/updateSentForm',
        data: data,
        params: {},
        that,
        method: 'post',
    })
}